import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { SupplierRequestListObjectType, SupplierRequestType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import useSupplierRequestSendEmail from '../model/useSupplierRequestSendEmail';
import SupplierRequestsTableBody from './SupplierRequestsTableBody';

interface SupplierRequestsTableProps {
    requests: SupplierRequestType[];
    showSpinner: boolean;
    canOps: boolean;
    onOpen: (requestId: number) => void;
    onClone: (row: SupplierRequestType) => void;
    onChanged: () => void;
    onFilterByObject: (object: SupplierRequestListObjectType) => void;
}

const SupplierRequestsTable = ({
    requests,
    showSpinner,
    canOps,
    onOpen,
    onClone,
    onChanged,
    onFilterByObject,
}: SupplierRequestsTableProps) => {
    const { t } = useTranslation(['Vendors']);
    const { openSendEmail } = useSupplierRequestSendEmail({ onChanged });

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="SupplierRequestsTable table-hover mb-0 align-middle">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-vendor">{t('supplierRequests.colVendor')}</td>
                            <td className="head-objects">{t('supplierRequests.colObjects')}</td>
                            <td className="head-status">{t('supplierRequests.colStatus')}</td>
                            <td className="head-date">{t('supplierRequests.colDate')}</td>
                            <td className="head-username">{t('supplierRequests.colUser')}</td>
                            <td className="head-note" title={t('supplierRequests.colNote')}></td>
                            <td className="head-action">{t('supplierRequests.colActions')}</td>
                        </tr>
                    </thead>
                    <SupplierRequestsTableBody
                        requests={requests}
                        canOps={canOps}
                        onOpen={onOpen}
                        onClone={onClone}
                        onChanged={onChanged}
                        onSendEmail={openSendEmail}
                        onFilterByObject={onFilterByObject}
                    />
                </Table>
            </div>
        </div>
    );
};

export default SupplierRequestsTable;
